import { CustomElement } from "../../core/CustomElement";
import "../link/index";
import "../forms/button/index";

export interface LinkListItem {
  id?: number;
  text: string;
  href: string;
  target?: string;
  date?: number;
}

export interface CCCLinkListState {
  title?: string;
  links: LinkListItem[];
  emptyListMsg?: string;
  moreLink?: string;
  createButton?: LinkListItem;
  pagination?: string;
}
export class CCCLinkList extends CustomElement {
  component: HTMLLinkElement = null;
  defaultEmptyListMsg = "Empty list";
  listeningToCreateButton = false;
  state: CCCLinkListState = {
    title: "",
    links: [],
  };
  paginationEnabled = false;

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
    };
    this.setupComponent();
    this.component = this.shadowDom.querySelector("#ccc-link-list");
    this.loading = true;
  }

  watchTitle(): void {
    // Select div
    const titleDiv: HTMLElement = this.component.querySelector(".title");
    this.hide(titleDiv);
    if (this.state.title && this.state.title !== "") {
      this.show(titleDiv);
      // set inner TEXT
      titleDiv.innerText = this.state.title;
    }
  }

  watchLinks(): void {
    // check if state.links is an array
    // console.log(this.state);
    if (Array.isArray(this.state.links)) {
      // select div
      const linksDiv: HTMLElement = this.component.querySelector(".links");
      // Clean html inside the div
      linksDiv.innerHTML = "";
      if (this.state.links.length > 0) {
        // iterate, for each link create a ccc-link element and add to container div
        this.state.links.forEach((link: LinkListItem) => {
          // console.log(link);
          const linkElWrapper = document.createElement("div");
          linkElWrapper.classList.add("link-item");
          const linkEl = document.createElement("ccc-link");
          linkEl.setAttribute("href", link.href);
          linkEl.innerText = link.text;
          if (link.target) {
            linkEl.setAttribute("target", link.target);
          }
          linkElWrapper.append(linkEl);
          linksDiv.append(linkElWrapper);
        });
      } else {
        // list of links is empty
        const message = this.state.emptyListMsg || this.defaultEmptyListMsg;
        // add message to link list container
        const p = document.createElement("p");
        p.classList.add("empty-list");
        p.innerText = message;
        linksDiv.append(p);
      }
    } else {
      // not an array
      console.error("Links state attr must be an array");
    }
  }

  watchMoreLink(): void {
    const moreLinkCnt: HTMLElement =
      this.component.querySelector(".more-link-cnt");

    if (this.state.moreLink && this.state.moreLink !== "") {
      const moreLink: CustomElement =
        this.component.querySelector(".more-link");
      moreLink.setAttribute("href", this.state.moreLink);

      moreLinkCnt.style.display = "block";
    } else {
      moreLinkCnt.style.display = "none";
    }
  }

  watchCreateButton(): void {
    const createBtnCnt: HTMLElement =
      this.component.querySelector(".create-btn-cnt");

    if (this.state.createButton) {
      const createBtn: CustomElement =
        this.component.querySelector(".create-btn");
      createBtn.setAttribute("text", this.state.createButton.text);

      if (!this.listeningToCreateButton) {
        this.listeningToCreateButton = true;
        createBtn.addEventListener("ccc-button-click", () => {
          this.goToCreateLink();
        });
      }
      createBtnCnt.style.display = "block";
    } else {
      createBtnCnt.style.display = "none";
    }
  }

  watchPagination(): void {
    const paginationButton: HTMLElement =
      this.component.querySelector(".pagination-btn");

    if (this.state.pagination) {
      paginationButton.setAttribute("text", this.state.pagination);
    }
  }

  showPagination(): void {
    if (!this.paginationEnabled) {
      const paginationBar: HTMLElement =
        this.component.querySelector(".pagination");
      const paginationButton: HTMLElement =
        this.component.querySelector(".pagination-btn");

      paginationBar.style.display = "flex";
      this.paginationEnabled = true;

      paginationButton.addEventListener("ccc-button-click", () => {
        const event = new Event("ccc-link-list-pagination");
        this.dispatchEvent(event);
      });
    }
  }

  hidePagination(): void {
    if (this.paginationEnabled) {
      const paginationBar: HTMLElement =
        this.component.querySelector(".pagination");

      paginationBar.style.display = "none";
      this.paginationEnabled = false;
    }
  }

  goToCreateLink(): void {
    if (this.state.createButton.href && this.state.createButton.href !== "") {
      window.location.href = this.state.createButton.href;
    }
  }
}

// define component
if (!customElements.get("ccc-link-list")) {
  customElements.define("ccc-link-list", CCCLinkList);
}
